module.exports = __webpack_public_path__ + "public/images/icons/uae.096971010af0cad52ab997a513b23c19.png";